import { CancelIcon } from 'BreetAssets';
import { type ISelectInputOption, SelectInput } from 'BreetComponents';
import type { DropdownOptionType } from 'BreetHelpers';
import { useCallback } from 'react';

import type { IWalletTransactionsFilter } from '../WalletTransactions.helpers';

const WithdrawalFilter = ({
	handleSelectedFilterChange,
	settlementValue,
	setSettlementValue,
	setStatusValue,
	statusValue,
	toggleVisibility,
}: IWalletTransactionsFilter) => {
	const handleSettlement = useCallback(
		(value: ISelectInputOption) => {
			setSettlementValue(value.value as string);
		},
		[setSettlementValue]
	);

	const handleStatus = useCallback(
		(value: ISelectInputOption) => {
			handleSelectedFilterChange?.({ status: value as DropdownOptionType });
			setStatusValue(value.value as string);
		},
		[handleSelectedFilterChange, setStatusValue]
	);

	const resetFilter = useCallback(() => {
		setSettlementValue('');
		setStatusValue('');
		handleSelectedFilterChange?.({});
		toggleVisibility?.();
	}, [handleSelectedFilterChange, setSettlementValue, setStatusValue, toggleVisibility]);

	return (
		<div className='appfilter dropdownshadow'>
			<CancelIcon
				className='svg-dark svg-dark-outline svg-dark-fill-circle cursor_pointer appfilter_closeicon'
				variant='dropdown'
				onClick={resetFilter}
			/>
			<SelectInput
				label='Settlement Type'
				defaultOption={{ label: 'Selection', value: '' }}
				onChange={handleSettlement}
				value={settlementValue}
				options={[
					{
						label: 'Admin action',
						value: 'edits',
					},
					{
						label: 'Withdrawals',
						value: 'withdrawals',
					},
				]}
			/>
			<SelectInput
				label='Status'
				defaultOption={{ label: 'Selection', value: '' }}
				value={statusValue}
				onChange={handleStatus}
				options={[
					{
						label: 'Completed',
						value: 'completed',
					},
					{
						label: 'Pending',
						value: 'pending',
					},
					{
						label: 'Processing',
						value: 'processing',
					},
					{
						label: 'Reversed',
						value: 'reversed',
					},
				]}
			/>
		</div>
	);
};

export default WithdrawalFilter;
